import React from 'react'

function Apex() {
  return (
    <div>Apex</div>
  )
}

export default Apex